module.exports = __webpack_public_path__ + "static/media/h5备份 7.7597438b.jpg";